<ws-modal-wrapper headerLabel="Responsibility Setup Exceptions"
                  (cancel)="bsModalRef.hide()">
        @if (isLoading) {
            <div class="text-center" style="margin-top: 50px; text-align: center;">
                <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
            </div>
        }
        @if (!isLoading && clientServiceExceptions) {
            <div>
                <div class="exception-details" style="margin-top:-28px;">
                    <div class="exception-details-breadcrumbs">
                        @if (clientServiceExceptions.parentEntityId) {
                            <button class="ace-btn btn-text icon-dark"
                                    (click)="changeEntityContext(clientServiceExceptions.parentEntityId, clientServiceExceptions.parentEntityTypeId)"
                                    style="padding: 5px;"
                                    data-qa="client-service-exceptions-nav-up">
                                <i class="fa fa-arrow-up"></i>
                            </button>
                        }
                        {{ clientServiceExceptions.entityName }}
                        <button class="float-end ace-btn btn-text icon-dark" style="padding:5px;" (click)="initModal()"
                                data-qa="client-service-exceptions-refresh">
                            <i class="fa fa-refresh"></i>
                        </button>
                    </div>
                    <div class="exception-details-filter" style="margin-bottom: 8px;">
                        <div style="width: 47%; display: inline-block">
                            <label for="client-service-exceptions-client-service-filter">Client Service:</label><br />
                            <select id="client-service-exceptions-client-service-filter" multiple style="width: 100%;"
                                    (change)="clientServicesChanged($event.target)"
                                    data-qa="client-service-exceptions-client-service-filter">
                                @for (clientService of clientServicesTypes; track clientService; let i = $index) {
                                    <option [selected]="clientServiceIds.includes(clientService.id)"
                                            [value]="clientService.id"
                                            [attr.data-qa]="'client-service-exceptions-client-service-option-' + i">{{ clientService.name }}
                                    </option>
                                }
                            </select>
                        </div>
                        <div style="width: 44%; position: absolute; margin-left: 19px; display: inline-block">
                            <label for="client-service-exceptions-property-type-filter">Property Type:</label><br />
                            <select id="client-service-exceptions-property-type-filter" multiple style="width: 100%;"
                                    (change)="propertyTypesChanged($event.target)"
                                    data-qa="client-service-exceptions-property-type-filter">
                                @for (property of propertyTypes; track property; let i = $index) {
                                    <option [selected]="propertyTypeIds.includes(property.id)" [value]="property.id"
                                            [attr.data-qa]="'client-service-exceptions-property-type-option-' + i">{{ property.name }}
                                    </option>
                                }
                            </select>
                        </div>
                    </div>
                </div>
                <div class="card panel-flat-color primary-panel small-panel"
                     style="margin-bottom: 8px; max-height: 300px;">
                    <div class="panel-flat-header small-header" style="color: var(--ace-neutral-700);">
                        <h3>{{ clientServiceExceptions.entityName }} Info</h3>
                    </div>
                    <div class="panel-flat-body" style="min-height: unset; height: 70px; max-height: 70px;">
                        <table style="width: 100%">
                            <thead>
                            <tr>
                                <th>Client Service</th>
                                <th>Property Type</th>
                                <th>Responsibility</th>
                            </tr>
                            </thead>
                            <tbody>
                                @for (responsibility of clientServiceExceptions.entityResponsibilities; track responsibility) {
                                    <tr>
                                        <td>{{ responsibility.clientServiceName }}</td>
                                        <td>{{ responsibility.propertyTypeName }}</td>
                                        <td>{{ getAssigneeLabelForResponsibility(responsibility) }}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card panel-flat-color primary-panel small-panel">
                    <div class="panel-flat-header small-header"
                         style="color: var(--ace-neutral-700); position: relative;">
                        <h3>Overrides (Exceptions)</h3>
                        @if (clientServiceExceptions.isTopLevel || clientServiceExceptions.entityTypeId === EntityTypes.Company) {
                            <span class="float-end include-all-switch">
                                <ws-switch [(ngModel)]="includeAll"
                                           (selectedOptionChanged)="initModal()"
                                           data-qa="client-service-exceptions-include-all">
                                </ws-switch>
                                Include All
                            </span>
                        }
                    </div>
                    <div class="panel-flat-body" style="max-height: 350px; padding: 10px 8px;">
                        <table style="border-collapse: separate; border-spacing: 0 8px; width: 100%;">
                            <thead>
                            <tr>
                                <th style="width: 25px; padding-left: 6px;">
                                    @if (!isInactive) {
                                        <input type="checkbox"
                                               [indeterminate]="selectedCount > 0 && selectedCount < clientServiceExceptions.children.length"
                                               [checked]="selectedCount === clientServiceExceptions.children.length"
                                               (click)="toggleAllResponsibilitySelections()"
                                               data-qa="client-service-exceptions-select-all" />
                                    }
                                </th>
                                <th style="width: 18%">Company Name</th>
                                <th style="width: 18%">Site Name</th>
                                <th style="width: 18%">Parcel Name</th>
                                <th style="width: 30px;">State</th>
                                <th style="width: 18%">Client Service</th>
                                <th style="width: 18%">Responsibility</th>
                            </tr>
                            </thead>
                            <tbody>
                                @for (exception of clientServiceExceptions.children; track exception; let i = $index) {
                                    <tr
                                        (click)="toggleResponsibilitySelection(exception)"
                                        [style.background-color]="exception.isSelected ? '#ecf5ff' : 'white'"
                                        [attr.data-qa]="'client-service-exceptions-row-' + i">
                                        <td style="padding-left: 6px;">
                                            <input type="checkbox" [(ngModel)]="exception.isSelected"
                                                   [attr.data-qa]="'client-service-exceptions-select-' + i" />
                                        </td>
                                        <td>
                                            <span class="anchor-style" role="button" tabindex="0"
                                                  (click)="navigateToEntity(exception, EntityTypes.Company)"
                                                  (keyup.enter)="navigateToEntity(exception, EntityTypes.Company)"
                                                  [attr.data-qa]="'client-service-exceptions-company-link-' + i">{{ exception.companyName }}
                                            </span>
                                        </td>
                                        <td>
                                            <span ng-if="exception.siteName">
                                                <span class="anchor-style" role="button" tabindex="0"
                                                      (click)="navigateToEntity(exception, EntityTypes.Site)"
                                                      (keyup.enter)="navigateToEntity(exception, EntityTypes.Site)"
                                                      [attr.data-qa]="'client-service-exceptions-site-link-' + i">
                                                    {{ exception.siteName }}
                                                </span>
                                            </span>
                                            @if (!exception.siteName) {
                                                <span>--</span>
                                            }
                                        </td>
                                        <td>
                                            @if (exception.parcelAcctNum) {
                                                <span>
                                                    <span class="anchor-style" role="button" tabindex="0"
                                                          (click)="navigateToEntity(exception, EntityTypes.Parcel)"
                                                          (keyup.enter)="navigateToEntity(exception, EntityTypes.Parcel)"
                                                          [attr.data-qa]="'client-service-exceptions-parcel-link-' + i">
                                                        {{ exception.parcelAcctNum }}
                                                    </span>
                                                </span>
                                            }
                                            @if (!exception.parcelAcctNum) {
                                                <span>--</span>
                                            }
                                        </td>
                                        <td>
                                            {{ exception.state }}
                                        </td>
                                        <td>
                                            {{ exception.clientServiceName }}
                                        </td>
                                        <td style="padding-right: 6px;">
                                            <span>
                                                {{ getAssigneeLabelForChildResponsibility(exception) }}
                                            </span>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        }

    <ng-container modal-footer>
        @if (!isLoading) {
            <div class="d-flex justify-content-between ws-stretch-width">
                <div>
                    @if (selectedCount > 0 && canEditCompanySetup) {
                    <div>
                        <button class="ace-btn btn-primary has-icon"
                                style="margin-left: 42px; margin-top: 6px;"
                                [popover]="assignmentTemplate"
                                [isOpen]="showPopover"
                                placement="top"
                                #assignmentPopover="bs-popover"
                                [outsideClick]="true"
                                data-qa="client-service-exceptions-assignment-popover">
                            <i class="fa fa-user"></i>
                        </button>
                        @if (showDatePicker) {
                            <label for="client-service-exceptions-effective-date"
                                   style="width:140px; vertical-align: middle; margin-top:5px; padding-left: 10px; margin-right: 20px;">
                                <weissman-datetime id="client-service-exceptions-effective-date"
                                                   [(inputDate)]="setDateFrom"
                                                   [dateOnly]="true"
                                                   [readOnly]="false"
                                                   [direction]="'up'"
                                                   data-qa="client-service-exceptions-effective-date">
                                </weissman-datetime>
                            </label>
                        }
                        @if (!assignmentSaved && (updateWorkflowType >= 0 || (updateWorkflowType === CONSULTING_ENGAGEMENT && consultingEngagementId))) {
                            <button class="ace-btn btn-primary btn-success has-icon"
                                    tooltip="Apply Changes"
                                    (click)="applyChanges()"
                                    [disabled]="showDatePicker && !setDateFrom"
                                    data-qa="client-service-exceptions-apply">
                                <i class="fa fa-save"></i>
                            </button>
                        }
                    </div>
                }
            </div>
            <button class="ace-btn btn-secondary" (click)="bsModalRef.hide()" data-qa="client-service-exceptions-close">
                Close
            </button>
        </div>
        }
    </ng-container>
</ws-modal-wrapper>

<ng-template #assignmentTemplate>
    <!-- account handler option-->
    <div class="radio">
        <label>
            <input type="radio" (change)="changeAssignmentSelection()" [(ngModel)]="updateWorkflowType"
                   [value]="WorkflowUserTypes['ACCOUNTHANDLER'].id"
                   data-qa="client-service-exceptions-assign-account-handler">
            Account Handler
        </label>
    </div>

    <!--jurisdiction specialist (only available inside ryan instance)-->
    @if (isCurrentInstanceRyan) {
        <div class="radio">
            <label>
                <input type="radio" (change)="changeAssignmentSelection()" [(ngModel)]="updateWorkflowType"
                       [value]="WorkflowUserTypes['JURISDICTIONSPECIALIST'].id"
                       data-qa="client-service-exceptions-assign-jurisdiction-specialist">
                Jurisdiction Specialist
            </label>
        </div>
    }

    <!-- consultant option (only for for consulting clients) -->
    @if (isConsultingClient() && consultingEngagements && consultingEngagements.length) {
        <div class="radio">
            <label>
                <input type="radio"
                       (change)="consultingEngagements.length === 1 ? changeConsultingEngagement(consultingEngagements[0].consultingEngagementId) : changeAssignmentSelection()"
                       [(ngModel)]="updateWorkflowType" [value]="CONSULTING_ENGAGEMENT"
                       data-qa="client-service-exceptions-assign-consultant">
                Consultant
                <!-- only one consultant available - just show their name -->
                @if (consultingEngagements.length === 1) {
                    <span> - {{ consultingEngagements[0].name }}</span>
                }
            </label>
            <!--more than one consultant available - show dropdown for user to select-->
            @if (consultingEngagements.length > 1) {
                <div class="consultant-selector">
                    <select name="consultingEngagement"
                            class="form-select form-select-sm"
                            style="width: auto;"
                            [disabled]="updateWorkflowType >= 0 || !updateWorkflowType"
                            (change)="changeConsultingEngagementFromSelect($event.target)"
                            data-qa="client-service-exceptions-consultant-select">
                        <option value="null" selected data-qa="client-service-exceptions-consultant-option-0"></option>
                        @for (ce of consultingEngagements; track ce; let i = $index) {
                            <option [value]="ce.consultingEngagementId"
                                    [attr.data-qa]="'client-service-exceptions-consultant-option-' + (i + 1)">{{ ce.name }}
                            </option>
                        }
                    </select>
                </div>
            }
        </div>
    }

    <!-- specific individual -->
    <div class="radio">
        <label>
            <input type="radio" (change)="changeAssignmentSelection()" [(ngModel)]="updateWorkflowType"
                   [value]="WorkflowUserTypes['USER'].id" data-qa="client-service-exceptions-assign-user">
            Specific Individual
        </label>
        <div>
            <user-team-picker
                [user]="updateUser"
                (userChange)="setUser($event)"
                [entityTypeScope]="'Instance'"
                [entityIdScope]="instanceId"
                data-qa="client-service-exceptions-user-picker">
            </user-team-picker>
        </div>
    </div>

    <!--N/A option-->
    <div class="radio">
        <label>
            <input type="radio" (change)="changeAssignmentSelection()" [(ngModel)]="updateWorkflowType"
                   [value]="WorkflowUserTypes['NA'].id" data-qa="client-service-exceptions-assign-na">
            N/A
        </label>
    </div>
</ng-template>

